import WhyPodiemInPageBanner from "@/core/infrastructure/repository/why_podiem/WhyPodiemInPageBanner"
import hasData from "@/core/domain/specification/hasData"

export default class WhyPodiemInPageBannerService {
    whyPodiemInPageBanner: WhyPodiemInPageBanner

    constructor() {
        this.whyPodiemInPageBanner = new WhyPodiemInPageBanner()
    }

    async process() {
        const { data, totalCount } = await this.whyPodiemInPageBanner.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
